module.exports = __webpack_public_path__ + "img/application-images-mb.fc625a1.webp";